import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'

export const state = {
  contract: null
}

const namespaced = true

export const contracts = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
